module.exports = __webpack_public_path__ + "6fd99c97a9a783483d3c02d4437a7d4a.woff";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-regular-italic.woff
// module id = 76
// module chunks = 0